import * as Immutable from "immutable";
import { getAuthServicePlugin } from "util/AuthenticationService";
const configFromJson = (config) => {
  const authService = getAuthServicePlugin(config.type, true);
  if (authService && typeof authService.configFromJson === "function") {
    return authService.configFromJson(config);
  }
  return config;
};
const configToJson = (config) => {
  const authService = getAuthServicePlugin(config.type, true);
  if (authService && typeof authService.configToJson === "function") {
    return authService.configToJson(config);
  }
  return config;
};
export default class AuthenticationBackend {
  constructor(id, title, description, defaultRoles, defaultUserTimezone, config) {
    this._value = {
      id,
      title,
      description,
      defaultRoles,
      defaultUserTimezone,
      config
    };
  }
  get id() {
    return this._value.id;
  }
  get title() {
    return this._value.title;
  }
  get description() {
    return this._value.description;
  }
  get defaultRoles() {
    return this._value.defaultRoles;
  }
  get defaultUserTimezone() {
    return this._value.defaultUserTimezone;
  }
  get config() {
    return this._value.config;
  }
  toBuilder() {
    const { id, title, description, defaultRoles, defaultUserTimezone, config } = this._value;
    return new Builder(
      Immutable.Map({
        id,
        title,
        description,
        defaultRoles,
        defaultUserTimezone,
        config
      })
    );
  }
  toJSON() {
    const { id, title, description, defaultRoles = Immutable.List(), defaultUserTimezone, config } = this._value;
    const formattedConfig = configToJson(config);
    return {
      id,
      title,
      description,
      default_roles: defaultRoles.toJS(),
      default_user_timezone: defaultUserTimezone,
      config: formattedConfig
    };
  }
  static fromJSON(value) {
    const {
      id,
      title,
      description,
      default_roles: defaultRoles,
      default_user_timezone: defaultUserTimezone,
      config
    } = value;
    const formattedConfig = configFromJson(config);
    return new AuthenticationBackend(
      id,
      title,
      description,
      Immutable.List(defaultRoles),
      defaultUserTimezone,
      formattedConfig
    );
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  title(value) {
    return new Builder(this.value.set("title", value));
  }
  description(value) {
    return new Builder(this.value.set("description", value));
  }
  defaultRoles(value) {
    return new Builder(this.value.set("defaultRoles", value));
  }
  config(value) {
    return new Builder(this.value.set("config", value));
  }
  build() {
    const { id, title, description, defaultRoles, defaultUserTimezone, config } = this.value.toObject();
    return new AuthenticationBackend(id, title, description, defaultRoles, defaultUserTimezone, config);
  }
}
